// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_t8zh873lU8L0k8Umr4{background-color:var(--background-primary-inverted-primary);z-index:var(--zIndex-BASE_2);vertical-align:inherit;padding:0;display:table-cell;position:-webkit-sticky;position:sticky;top:0;left:0}.G_t8zh873lU8L0k8Umr4.DgMDu9_FgJQForXct2CC:before{content:"";background:var(--black-20);width:1px;height:40px;position:absolute;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pinnedRow": `G_t8zh873lU8L0k8Umr4`,
	"borderRight": `DgMDu9_FgJQForXct2CC`
};
export default ___CSS_LOADER_EXPORT___;
